import { Form } from 'react-bootstrap';
import ChangeHighlightedImmutableUnderReviewControl from './ChangeHighlightedImmutableUnderReviewControl';
import React from 'react';
export default function ChangeHighglightedImmutableUnderReviewDropdown(_ref) {
  let {
    claim,
    object,
    valuesArray,
    valueInstanceTextFieldName = 'name',
    edittedObject,
    edittedObjectFieldName,
    userUnauthorizedToEdit,
    onChange,
    onBlur,
    refreshClaim,
    onCreate
  } = _ref;
  //backwards compatibility
  if (object) {
    claim = object;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: async e => {
      if (e.target.value !== '0') {
        await onChange(e);
      } else {
        onCreate && onCreate();
      }
    },
    onBlur: onBlur,
    disabled: claim.financials_locked || userUnauthorizedToEdit,
    name: edittedObjectFieldName,
    object: {
      ...edittedObject,
      claim: {
        ...claim
      }
    },
    size: "sm",
    controlAs: "select"
  }, valuesArray.map(instance => /*#__PURE__*/React.createElement("option", {
    key: instance.id,
    value: instance.value || instance.id
  }, instance[valueInstanceTextFieldName])), /*#__PURE__*/React.createElement("option", {
    key: null,
    value: null
  }), onCreate && /*#__PURE__*/React.createElement("option", {
    key: 0,
    value: 0
  }, "Add new")));
}